import { render, staticRenderFns } from "./GroupLessonsWidget.vue?vue&type=template&id=1e91e460&scoped=true"
import script from "./GroupLessonsWidget.vue?vue&type=script&lang=js"
export * from "./GroupLessonsWidget.vue?vue&type=script&lang=js"
import style0 from "./GroupLessonsWidget.vue?vue&type=style&index=0&id=1e91e460&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e91e460",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e91e460')) {
      api.createRecord('1e91e460', component.options)
    } else {
      api.reload('1e91e460', component.options)
    }
    module.hot.accept("./GroupLessonsWidget.vue?vue&type=template&id=1e91e460&scoped=true", function () {
      api.rerender('1e91e460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/GroupLessonsWidget.vue"
export default component.exports